import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent  {

  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  isLoading: BehaviorSubject<boolean>;

  constructor(private loaderService:LoaderService) {
      this.isLoading = this.loaderService.isLoading;
   }

}
